export const MIN_COLUMN_WIDTH = 200;
export const COLUMN_GAP = 30;

export const COPY_LOAN_DISABLED_REASON = 'The application is not completed yet';
